import React from "react";
import { ApplicationUser } from "../entities/ApplicationUser";

export interface BuilderPreviewState {
    user: ApplicationUser | null ;
    updateUser: (user: ApplicationUser | null) => void;
    showSnackBar: (message: string) => void;
}

export const BuilderPreviewContext = React.createContext<BuilderPreviewState>({} as any);

export function useBuilderPreview() {
	return React.useContext(BuilderPreviewContext);
}